import * as TwoFactorAuthSetupSteps from './TwoFactorAuthSetupSteps';
const STEP_ORDER = [TwoFactorAuthSetupSteps.CHOOSE_METHOD, TwoFactorAuthSetupSteps.REGISTER_HUBSPOT_WITH_GA, TwoFactorAuthSetupSteps.VERIFY_GOOGLE_AUTHENTICATOR, TwoFactorAuthSetupSteps.REGISTER_SMS, TwoFactorAuthSetupSteps.VERIFY_SMS, TwoFactorAuthSetupSteps.BACKUP_CODES, TwoFactorAuthSetupSteps.VERIFICATION_SUCCESSFUL];
export function indexOfStep(step) {
  return STEP_ORDER.indexOf(step);
}
export default STEP_ORDER;